import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ClientPaymentList from './ClientPaymentList';
import ClientPaymentAssign from './ClientPaymentAssign';
import ClientPaymentDetail from './ClientPaymentDetail';

const ClientPayments = () => {
  return (
    <Routes>
      <Route path="/" element={<ClientPaymentList />} />
      <Route path="/assign" element={<ClientPaymentAssign />} />
      <Route path="/:id" element={<ClientPaymentDetail />} />
      <Route path="*" element={<Navigate to="/memberships" replace />} />
    </Routes>
  );
};

export default ClientPayments;
